import axios from "axios";
import Cookies from "js-cookie";
import config from "../../config";

const baseUrl = config.baseUrl;
const Endpoint = "/api/getNovedades";

// Crear una instancia de Axios para configurar base URL y otras opciones
const api = axios.create({
  baseURL: config.baseUrl,
});

// Interceptor de solicitud para añadir el token de autorización
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const getNovedades = async (email) => {
  try {
    const response = await api.get(`${baseUrl}${Endpoint}/?email=${email}`);
    return {
      status: response.status,
      data: response.data.novedades,
      total_participantes: response.data.total_participantes,
    };
  } catch (error) {
    console.error("Error fetching novedades types:", error);
    return {
      status: error.response ? error.response.status : 500,
      message: "Error fetching novedades types",
    };
  }
};

export default getNovedades;
